import { Model } from '@vuex-orm/core'
import Ticket from "@/store/models/tickets/model";
import Question from "@/store/models/questions/model";
import { DateTime } from 'luxon'
import { get, round } from 'lodash'
import Position from '../positions/model'

export const MODE_TRAINING = 'Training'
export const MODE_EXAM = 'Exam'

export default class Test extends Model {
    static get entity () {
        return 'tests'
    }

    static fields () {
        return {
            id: this.uid(),
            ticketId: this.uid(),
            //positionId: this.uid().nullable(),
            ticket: this.belongsTo(Ticket, 'ticketId'),
            mode: this.string(''),
            answersCount: this.number(0),
            rightAnswersCount: this.number(0),
            remainingSeconds: this.number(0),
            answers: this.attr([]),
            startedAt: this.attr(''),
            finishedAt: this.attr(null).nullable(),
            questions: this.hasMany(Question, 'activityId'),
            //position: this.belongsTo(Position, 'positionId'),
        }
    }

    get position () {
        return get(this.$query().with([
            'ticket.position',
        ]).find(this.id), 'ticket.position')
    }

    get positionId () {
        return get(this.position, 'id')
    }

    get modeTranslate () {
        switch (this.mode) {
            case MODE_TRAINING:
                return 'Тренировка'
            case MODE_EXAM:
                return 'Аттестация'
            default:
                return '...'
        }
    }

    get calculatedRate () {
        if (this.ticket.questionsAmount === 0) {
            return 0
        }

        return round(( 5 / this.ticket.questionsAmount) * this.rightAnswersCount, 2)
    }

    get secondsFromStart() {
        return parseInt(DateTime.now().toUTC().diff(DateTime.fromISO(this.startedAt, {zone: 'UTC'}), ['seconds']).seconds)
    }

    get remainingTime () {
        if (!this.ticket) return 0
        return this.ticket.timeLimit - this.secondsFromStart
    }

    get isFinished() {
        return !!this.finishedAt || this.remainingTime <= 0
    }
}
